import { render, staticRenderFns } from "./DCItemsToCollectView.vue?vue&type=template&id=1a1a419e&"
import script from "./DCItemsToCollectView.vue?vue&type=script&lang=js&"
export * from "./DCItemsToCollectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports